import { useEffect, useState } from 'react'
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Legend
  } from "recharts";
import { useRemmitances } from '../../../../../hooks/useRemmitances';
import Skeleton from '../../../../../components/ui/Skeleton';

const WithDrawnYearStats = () => {
    const { getWithdrawnRemittancesYear  } = useRemmitances();

     const [stats, setStats] = useState(null);

     const COLORS = {
        delivered: "#FBD825",
        received: "#0b4170"
      };

        const currentYear = new Date().getFullYear();

      const formattedDataWithDrawn = (data) => {

        const monthMap = { 1: "Ene", 2: "Feb", 3: "Mar", 4: "Abril", 5: "May", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Sep", 10: "Oct", 11: "Nov", 12: "Dic"};
    
      const result = data.map((item) => {
          const month = monthMap[item?.Mes];
          return {
              name: month,
              delivered: item?.RemesasEntregadas,
              inProcess: item?.RemesasEnProceso
          };
          });
    
        return result;
      };

      
        const handleGetStatsUser = async () => {
              const abortController = new AbortController();
              const response = await getWithdrawnRemittancesYear(abortController.signal);
              const data = response?.payload;
              const formatData = formattedDataWithDrawn(data);
              
              setStats(formatData);
          };
      
          useEffect(() => {
              handleGetStatsUser();
          }, []);

         

  return (
    !stats ? (
        <Skeleton variant="rectangular" width="100%" height="350px" />
    ) : ( 
    <div className="dashboardCard m-0 py-6 w-100 h-100">
                <div>
                  {/* 1. Gráfica de barras para remesas mensuales */}
                  <h5 className="text-start text-center">Giros Mensuales - Periodo {currentYear}</h5>
                  <ResponsiveContainer width="100%" height={300}>
                    <BarChart data={stats}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis />
                      <Tooltip />
                      
                      <Legend
                        formatter={(value) => {
                          if (value === "delivered") {
                            return <span style={{ color: COLORS.delivered }}>Pagados</span>;
                          }
            
                          return value;
                        }}
                      />
                      <Bar dataKey="delivered" fill={COLORS.delivered} name="Pagados" />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
    </div>
  )
    )
}

export default WithDrawnYearStats

